import React, {useState} from 'react';
import {Modal, Switch} from "antd";
import ExportModal from "./ExportModal";

const RealTimeCapture = () => {
    const [openModal, setOpenModal] = useState(false)
    const [exportModal, setExportModal] = useState(false)
    const onChange = () => {
      
    }
    return (
        <div className="main-padding  ">
            <div className="camera-config-header">
                <span>Home</span>
                <img src="/icon/arrowleft.svg" alt=">"/>
                <span>Real-time Capture</span>
            </div>

            <div className="camera-config-content">
                <div className="control-header-cmcf my-avform">
                    <div className="d-flex align-items-center">
                        <div className="input-group" style={{width: "220px", height: "36px"}}>
                            <input type="datetime-local" className="form-control h-100"  aria-label="Recipient's username" aria-describedby="basic-addon2" />

                        </div>
                        <div className="input-group ml-24" style={{width: "220px", height: "36px"}}>
                            <input type="datetime-local" className="form-control h-100"  aria-label="Recipient's username" aria-describedby="basic-addon2" />
                        </div>
                        <div className="ml-24">
                            <button className="btn btn-primary  d-flex align-items-center "  type="button">
                                <img src="/icon/loupe.png"  className="mr-8" style={{marginTop: "-5px"}} alt="..."/>
                                Search
                            </button>
                        </div>
                            <div className="d-flex align-items-center ml-24"><span className="text-white mr-8" style={{whiteSpace: "nowrap"}}>Real time capture </span><Switch defaultChecked onChange={onChange}/></div>
                        <div style={{height: "36px"}}>
                            <button className="btn btn-success ml-24  " onClick={() => setOpenModal(true)}>Picture export</button>
                            <button className="btn btn-success ml-24  "  onClick={() => setExportModal(true)}>Exel export</button>

                        </div>
                    </div>
                </div>

        </div>
            <ExportModal
                setIsModalOffice={setOpenModal}
                isModalOffice={openModal}

            />

            <Modal title="Exel Export
"
                   open={exportModal}
                   onCancel={() => setExportModal(false)}
            >
                <div className="row mt-3">
                    <label className="font-family-medium   mb-3 col-md-6">Split the export form by quantity</label>
                    <div className="col-md-6">
                        <div className="number-counter">
                            <span className="minus">-</span>
                            <input type="text" value="1"/>
                            <span className="plus">+</span>
                        </div>
                    </div>
                </div>
                <div className="row mt-3">
                    <label className="font-family-medium   mb-3 col-md-6">Excel Picture Quality</label>
                    <div className="col-md-6">
                        <div className="number-counter">
                            <span className="minus">-</span>
                            <input type="text" value="1"/>
                            <span className="plus">+</span>
                        </div>
                    </div>
                </div>


            </Modal>
        </div>
    );
};

export default RealTimeCapture;